import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import './App.css';
import Home from './pages/home';
import Navbar from './layout/navbar';
import Sidebar from './layout/sidebar';
import Footer from './layout/footer';
import Gallery from './pages/gallery';
import GalleryItem from './pages/galleryItem';
import Login from './auth/login';
import AddGallery from './auth/addGallery';
import EditGallery from './auth/editGallery';
import ShowSideBar from './showSidebar/showsidebar';
import Calls from './components/calls';
import NotFound from './layout/404pages';
import { Analytics } from "@vercel/analytics/react"
import ServiceArticle from './pages/serviceArticle'; // Import ServiceArticle

function App() {
  return (
    <ChakraProvider>
      <Router>
        <div className="App font-['Poppinsr'] overflow-hidden">
          <Navbar />
          <Calls />
          <div className='mt-14'>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/gallery/:id" component={GalleryItem} />
              <Route path="/gallery" component={Gallery} />
              <Route path="/service/:serviceName" component={ServiceArticle} />
              <Route path="/login" component={Login} />
              <Route path="/add" component={AddGallery} />
              <Route path="/edit/:id" component={EditGallery} />
              <Route path="*" component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
      <Analytics />
    </ChakraProvider>
  );
}

export default App;
